import { env } from '~/env.mjs';

// This breaks apart emails like "x+stuff@mail.stably.ai"
// We also deal with dynamic emails like `x+${Date.now()}@mail.stably.ai`
// Thought: Maybe a regex here is nicer, but unsure how to write it atm
export const destructEmail = (email: string) => {
  const isDynamicValue = email.startsWith('`') && email.endsWith('`');
  const domainSplitSymbol = isDynamicValue ? '}@' : '@';
  const usernameSplitSymbol = isDynamicValue ? '+${' : '+';
  const cleanEmail = isDynamicValue ? email.slice(1, -1) : email;
  const [fullUsername, domain] = cleanEmail.split(domainSplitSymbol);
  const [orgName, usernameSuffix] = fullUsername.split(usernameSplitSymbol);
  return { orgName, usernameSuffix, domain, isDynamicValue };
};

// This extracts the email subaddressing from an email address
// E.g. "stably+stuff@mail.stably.ai" -> "stuff"
export const extractEmailUsernameSuffixValue = (value: string, emailOrgPrefix: string) => {
  const { orgName, usernameSuffix, domain } = destructEmail(value || '');
  if (emailOrgPrefix === orgName && domain === env.NEXT_PUBLIC_STABLY_EMAIL_DOMAIN) {
    return usernameSuffix;
  }
  return undefined;
};
